import { apiInstance, legacyV3Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const companyGroup = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV3Path()}/companygroup`,
      params
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3Path()}/companygroup`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3Path()}/companygroup/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV3Path()}/companygroup/${id}`
    })
  }
}

export default companyGroup
